import React, {useRef} from "react";
import {useHistory} from "react-router-dom";
import {InvestorGroupType, MemberGroup} from "../../../ClientManagement/models/InvestorGroupType";
import {AssetsSummary} from "../../models/Assets";
import ArrangeAssets from "./ArrangeAssets";
import {ReorderAssetRequest} from "./ReorderAssets";
import {putAssetsOrder} from "../../AssetsApiClient";
import {useAnalyticsTrackers} from "../../../utils/useAnalyticsTrackers";

type ArrangeAssetsContainerProps = {
    profileId: string,
    assetsSummary: AssetsSummary | undefined,
    investorGroup?: InvestorGroupType,
    memberGroup: MemberGroup
}
const ArrangeAssetsContainer = ({ profileId, assetsSummary, investorGroup, memberGroup }: ArrangeAssetsContainerProps) => {
    const history = useHistory();

    const openTimeRef = useRef<number | null>(null);
    const { page } = useAnalyticsTrackers("enableAssetsGoogleAnalytics");

    openTimeRef.current = window.performance.now();

    const handleSave = (reorderAssetRequest: ReorderAssetRequest) => {
        captureTimeOnArrangeAssetsPage()
        putAssetsOrder(profileId, reorderAssetRequest)
            .then(response => {
                if (response.status === 200) {
                    history.push(`/Profile/${profileId}/ClientProfile/AssetSummary`);
                }
            })
            .catch(error => {
                console.error('Could not update the order of the assets', error.message)
            });
    }

    const handleCancel = () => {
        captureTimeOnArrangeAssetsPage()
        history.goBack()
    }


    const captureTimeOnArrangeAssetsPage = () => {
        if (openTimeRef.current) {
            const duration = Math.round((window.performance.now() - openTimeRef.current) / 1000);
            page(`Expand_ArrangeAssetsPage`, {cd4_duration: duration});
        }
    }

    return (
            <ArrangeAssets
                profileId={profileId}
                assetsSummary={assetsSummary!}
                memberGroup={memberGroup}
                investorGroup={investorGroup!}
                onSave={handleSave}
                onCancel={handleCancel}
            />
    )
}

export default ArrangeAssetsContainer;